export const stations = [
  { id: "B828", name: "ACEGUA" },
  { id: "A826", name: "ALEGRETE" },
  { id: "A827", name: "BAGE" },
  { id: "A840", name: "BENTO GONCALVES" },
  //{ id: "A812", name: "CACAPAVA DO SUL" }, ***PANE***
  { id: "B822", name: "CACHOEIRA DO SUL" },
  { id: "B808", name: "CACHOEIRINHA" },
  { id: "A838", name: "CAMAQUA" },
  { id: "A897", name: "CAMBARA DO SUL" },
  { id: 'A884', name: 'CAMPO BOM' },
  { id: 'A879', name: 'CANELA' },
  { id: "A811", name: "CANGUCU" },
  { id: "B832", name: "CAPAO DA CANOA" },
  { id: "A887", name: "CAPAO DO LEAO (PELOTAS)" },
  { id: "B818", name: "CAXIAS DO SUL (AEROPORTO)" },
  { id: "B817", name: "CAXIAS DO SUL (CRIUVA)" },
  { id: "B812", name: "CHARQUEADAS" },
  { id: "A853", name: "CRUZ ALTA" },
  { id: "A881", name: "DOM PEDRITO" },
  { id: "A893", name: "ENCRUZILHADA DO SUL" },
  { id: "A828", name: "ERECHIM" },
  { id: "A854", name: "FREDERICO WESTPHALEN" },
  { id: "B826", name: "HERVAL" },
  { id: "A883", name: "IBIRUBÁ" },
  { id: "A836", name: "JAGUARAO" },
  { id: "A844", name: "LAGOA VERMELHA" },
  { id: "B813", name: "MINAS DO LEÃO" },
  { id: "B814", name: "MONTENEGRO" },
  //{ id: 'A878', name: 'MOSTARDAS' }, ***PANE***,
  { id: "B836", name: "PALMARES DO SUL" },
  //{ id: "A856", name: "PALMEIRA DAS MISSOES" }, ***PANE***
  { id: "B810", name:"PARQUE ELDORADO" },
  { id: "A839", name: "PASSO FUNDO" },
  { id: "B823", name: "PINHEIRO MACHADO" },
  { id: "A801", name: "PORTO ALEGRE - JARDIM BOTANICO" },
  { id: "B825", name: "PORTO ALEGRE- BELEM NOVO" },
  { id: "A831", name: "QUARAI" },
  { id: "A802", name: "RIO GRANDE" },
  {id: "A813", name: "RIO PARDO" },
  { id: "B819", name: "ROLANTE" },
  { id: "A803", name: "SANTA MARIA" },
  { id: "B816", name: "SANTA MARIA DO HERVAL" },
  //{ id: "A810", name: "SANTA ROSA" }, ***PANE***
  { id: "B830", name: "SANTA VITORIA DO PALMAR (CENTRO)" },
  { id: "A899", name: "SANTA VITORIA DO PALMAR (CHUÍ)" },
  { id: "B829", name: "SANTA VITORIA DO PALMAR (RESERVA TAIM)" },
  { id: "B821", name: "SANTANA BOA VISTA" },
  //{ id: "A804", name: "SANTANA DO LIVRAMENTO" }, **PANE**
  { id: "A833", name: "SANTIAGO" },
  { id: "B839", name: "SANTO ANTONIO DA PATRULHA" },
  { id: "A805", name: "SANTO AUGUSTO" },
  { id: "A830", name: "SAO BORJA" },
  { id: "A832", name: "SAO GABRIEL" },
  { id: "A829", name: "SAO JOSE DOS AUSENTES" },
  { id: "A852", name: "SAO LUIZ GONZAGA" },
  //{ id: "A889", name: "SAO VICENTE DO SUL" }, ***PANE***
  { id: "B809", name: "SAṔUCAIA DO SUL" },
  { id: "A894", name: "SERAFINA CORREA" },
  { id: "B811", name: "SERTAO SANTANA" },
  { id: "A837", name: "SOLEDADE" },
  { id: "B841", name: "TORRES" },
  { id: 'A834', name: 'TRAMANDAI' },
  //{ id: "A809", name: "URUGUAIANA" }, ***PANE***
  { id: "A886", name: "TUPANCIRETÃ" },
  { id: "A880", name: "VACARIA" },
];
